import { connect } from 'react-redux';
import { enterCharForAdminPassword } from 'redux/app/app.actions';
import AdminPopupPad from './AdminPopupPad.component';

const mapDispatchToProps = {
  onPress: enterCharForAdminPassword,
};

export default connect(undefined, mapDispatchToProps)(AdminPopupPad);
